/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState } from 'react'
import { useSwipeable } from 'react-swipeable'
import type { BottegaBlock } from '@velasca/types'
import { $bottega_blocks } from '@velasca/utils/globals'
import { sanitizeHTML } from '@velasca/utils/sanitize-html'

const Slider = () => {
  const [current, setCurrent] = useState(0)
  const handlers = useSwipeable({
    onSwipedLeft: () => {
      setCurrent(current + 1 < $bottega_blocks.length ? current + 1 : current)
    },
    onSwipedRight: () => {
      setCurrent(current - 1 >= 0 ? current - 1 : current)
    },
    preventScrollOnSwipe: true,
    trackMouse: true,
  })

  return (
    <div {...handlers} className="slider-section col-md-10">
      <div className="text-slides-container">
        <div
          className="text-slides"
          style={{
            transform: `translateY(-50%) translateX(${current * -100}%)`,
          }}
        >
          {$bottega_blocks.map(
            ({ pretitle, title, paragraph }: BottegaBlock, i: number) => (
              <div className="slide" key={i}>
                {pretitle && (
                  <div
                    className="pretitle"
                    dangerouslySetInnerHTML={sanitizeHTML(pretitle)}
                  ></div>
                )}

                {title && (
                  <h4 dangerouslySetInnerHTML={sanitizeHTML(title)}></h4>
                )}

                {paragraph && (
                  <p dangerouslySetInnerHTML={sanitizeHTML(paragraph)}></p>
                )}
              </div>
            ),
          )}
        </div>
        <div className="selector-dots">
          {$bottega_blocks.map((bottega: BottegaBlock, i: number) => (
            <div
              className={`dot ${i === current ? 'active' : ''}`}
              key={i}
              onClick={() => {
                setCurrent(i)
              }}
            ></div>
          ))}
        </div>
      </div>

      <div className="image-slides">
        {$bottega_blocks.map((bottega: BottegaBlock, i: number) => (
          <img
            className={i === current ? 'active' : ''}
            src={bottega.visual_bottom_01}
            alt={`${bottega.title} | Velasca`}
            key={i}
          />
        ))}
      </div>
    </div>
  )
}

export default Slider
